<template>
  <div id="fixed-invitation">
      <div class="step-box">
          <span class="number">1</span>
          <span>生成邀请链接</span>
          <span class="number">2</span>
          <span>复制并发送给好友</span>
      </div>
      <div class="invite-code">邀请码：<span>{{inviteCode}}</span></div>
      <div class="create-button" @click="createUrl">点击生成邀请链接</div>
      <div class="tip">注：邀请链接单次有效，不可重复使用</div>
      <div v-show="urlShow" class="url-mask">
          <!-- @click.stop.prevent="clickMask"
          @click.stop="()=> { return }" -->
          <div class="dialog">
              <div class="dia-title">我的邀请链接</div>
              <div class="dia-body">
                  <span class="url">{{showInviteUrl}}</span>
                  <span class="my_url" @click.prevent="copyUrl">
                    <img class="copy-btn" src="@/assets/fixed-invitation/copy.png" alt="" >
                  </span>
                  <div class="tip">*单次有效，不可重复使用</div>
              </div>
          </div>
          <div class="close-btn" @click="clickMask"></div>
      </div>
      <div class="alert" v-show="alertShow">
        <span>{{message}}</span>
      </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
    name: 'FixedInvitation',
    data() {
        return {
            inviteCode: '',
            urlShow: false,
            alertShow: false,
            message: '',
            inviteUrl: '',
            showInviteUrl: '加载中请稍后...'
        }
    },
    mounted() {
        this.inviteCode = this.$route.query.inviteCode
        this.username = this.$route.query.username ? this.$route.query.username : 123456;
        let token = this.$route.query.auth;
        // debugger
        token = decodeURI(token)
        this.$MyAxios.axiosInstance.defaults.headers.common['Authorization'] = token;
    },
    computed: {
        showInviteUrl() {
            let host = window.location.host
            return host.substr(0,6) + "..."
        }
    },
    methods: {
        createUrl() {
            this.$MyAxios.get('/api/user/invites/broker/findRegisterInviteCode', {
                params: {
                    username: this.username,
                }
            }, response => {
                if(response.code == 1) {
                    const host = window.location.protocol + "//" + window.location.host
                    this.inviteUrl = `${host}/fixed-invitation-register?inviteCode=${this.inviteCode}&registCode=${response.data}`;
                    this.showInviteUrl = `${window.location.host.substr(0,12)}......${response.data}`
                }
            }, error => {
                this.showAlert(error)
            })
            this.urlShow = true
        },
        clickMask () {
            this.urlShow = false
            this.showInviteUrl = '加载中请稍后...'
        },
        copyUrl() {
            if(this.showInviteUrl === '加载中请稍后...') {
                return
            }
            let code = this.inviteUrl
            // let code = '123123'
            let clipboard = new Clipboard('.my_url', {
                text: function () {
                    return code
                }
            })
            console.log(clipboard)
            clipboard.on('success', e => {
                this.showAlert('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert('复制失败，请长按邀请码进行复制')
                clipboard.destroy()
            })
        },
        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },
    }
}
</script>

<style lang='less'>
#fixed-invitation {
    min-height: 100vh;
    width: 100%;
    background-color: #ffffff;
    background-image: url(../../assets/fixed-invitation/back.png);
	background-size: 100% auto;
	background-repeat: no-repeat;
    position: relative;
    padding: 60px 0px 0px 0px;
    // img {
    //     pointer-events: none;
    // }
    .step-box {
        height: 88px;
        width: 690px;
        border-radius: 44px;
        margin: 0 auto;
        background: #FFF6E8;
        line-height: 88px;
        margin-bottom: 456px;
        span {
            display: inline-block;
            vertical-align: middle;
            margin-right: 30px;
            color: #33333A;
            font-size: 32px;
            font-weight: 400;
            &.number {
                height: 48px;
                width: 48px;
                border-radius: 24px;
                background: #FFA41F;
                line-height: 48px;
                text-align: center;
                margin-right: 20px;
                color: #FFFFFF;
                font-weight: 500;
            }
        }
    }
    .invite-code {
        height: 72px;
        width: 334px;
        border-radius: 36px;
        background: #FFF6E8;
        color: #33333A;
        font-size: 28px;
        font-weight: 500;
        line-height: 72px;
        margin: 0 auto 60px auto;
    }
    .create-button {
        height: 88px;
        width: 690px;
        border-radius: 44px;
        background: linear-gradient(90deg,#ffa41f 0%, #ff5e03 100%);
        color: #FFFFFF;
        font-size: 32px;
        font-weight: 500;
        line-height: 88px;
        margin: 0 auto 20px auto;
    }
    .tip {
        font-size: 28px;
        line-height: 40px;
        color: #EB4236;
    }
    .url-mask {
        position: absolute;
        height: 100vh;
        width: 100vw;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        padding: 200px 0 0 0;
        z-index: 1;
        .dialog {
            position: absolute;
            height: 290px;
            width: 560px;
            border-radius: 16px;
            background: #ffffff;
            margin: 0 auto;
            left: 50%;
            transform: translateX(-50%);
            z-index: 2;
            .dia-title {
                height: 108px;
                border-bottom: 1px solid #EBECF0;
                line-height: 108px;
                font-size: 32px;
                color: #33333A;
            }
            .dia-body {
                padding: 40px 30px;
                text-align: left;
            }
            .url {
                display: inline-block;
                width: 460px;
                height: 40px;
                line-height: 40px;
                vertical-align: middle;
                color: #33333A;
                font-size: 28px;
                font-weight: 500;
                margin-bottom: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .copy-btn {
                width: 40px;
                height: 40px;
                margin-bottom: 20px;
                cursor: pointer;
                vertical-align: middle;
            }
        }
        .close-btn {
            // position: absolute;
            // bottom: 40%;
            // width: 100%;
            // font-size: 88px;
            // color: #ffffff;
            // text-align: center;
            // left: 0;
            background: url(../../assets/fixed-invitation/msg_close.png) 0 0 no-repeat;
            background-size: 60%;
            width: 80px;
            height: 80px;
            transform: translate(-40px);
            position: absolute;
            left: 50%;
            top: 50%;
        }
    }
    
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-100px);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>